<template>
  <div>
    <img
      src="../../assets/banner_2025.jpg"
      alt=""
      style="width: 100%; margin-bottom: 50px;margin-top: 50px"
    />
    <h1 class="title_second">2025“敦煌杯”中国器乐演奏比赛</h1>
    <h1 class="title_second">北美赛区活动章程</h1>
    <!-- <h1 class="title_first">活动章程</h1> -->
    <div class="constitution">
      <p style="margin-bottom: 24px"></p>
      <p>传播中华文化，让世界听懂中国。</p>
      <p>
        “ ‘敦煌杯’中国器乐演奏比赛（北美赛区）”将于2025年12月在加拿大温哥华举办，本次比赛在延续二胡赛事传统的基础上，首次将琵琶、古筝等多项民族乐器纳入北美赛区正式比赛项目，标志着"敦煌杯"在北美地区的赛事体系进一步完善，为中国民族音乐在海外的发展与传播开辟更广阔的舞台。
      </p>
      <p>
        “敦煌杯”中国民族器乐演奏比赛北美赛区将对接国际顶级音乐赛事标准，结合北美实际情况，科学组织实施各项赛程，提升中国民族乐器在世界范围的认知度。此次比赛项目的增设，不仅丰富了赛事内容，更为北美地区的民乐人提供了更全面的展示平台。
      </p>
      <p>
        “敦煌杯”中国民族器乐系列艺术菁英展演、比赛活动自2010年创办以来，以权威的评委团队、严谨的赛制和丰富的学术活动吸引了越来越多的专业、业余学习者，逐渐被专业人士和广泛的世界中华民乐爱好者群体认可，已成为一项影响力深远的民族音乐活动品牌。并于近年来先后在日本、新加坡设立国际赛区按照国际音乐比赛标准独立运营，取得良好社会效应。本次北美赛区多项民族乐器比赛的设立，将进一步推动中国民族音乐在国际舞台上的多元化发展。
      </p>
      <div class="key_point">
        <span class="bc_red">一、活动组织机构</span>
        <br />
        <span class="bold">联合主办单位：</span>中国乐器协会
        <p class="content">
          “敦煌杯”中国民族器乐比赛组委会
          <br />
          上海民族乐器一厂有限公司
          <br />
          加拿大英才中乐协会
          <br />
          美国国际演奏艺术友好协会
          <br />
          北京华夏璇音艺术传播中心
          <br />
        </p>
        <span class="bold">北美赛区承办单位：</span>加拿大英才音乐学院
      </div>
      <!-- <div class="key_point">
        <span class="bc_red">二、活动组委会</span>
          <br>
        <span class="bold">组委会主任：</span>孙瑞勇（中国乐器协会副理事长）
          <br>
        <span class="bold">组委会副主任：</span><span class="small">（按姓氏笔划排序）</span>
          <br>
        王国振（上海民族乐器一厂有限公司总经理）
          <br>
        刘 勇 （中国乐器协会秘书长）
          <br>
        杜怡璇（北京华夏璇音艺术传播中心总经理）
          <br>
        林汉崇（新加坡南洋艺术学院音乐学院院长）
          <br>
        杨忠才（加拿大英才音乐学院院长）
          <br>
        武乐群 （NOP日本二胡振兴会理事长）
          <br>
        费维耀（上海音乐出版社、上海文艺音像电子出版社社长，总编辑）
          <br>
        <span class="bold">组委会秘书长：</span>杜怡璇
      </div> -->
      <div class="key_point">
        <span class="bc_red">二、北美赛区比赛评委会</span>
        <br />
        <span class="bold">评委会荣誉主席：</span>
        <br />
        刘长福：著名二胡演奏家、教育家，中央音乐学院资深二胡导师、教授，中国音乐家协会二胡学会顾问委员会主任，中国音乐家协会“刘天华研究会”副会长，中国民族管弦乐学会胡琴专业委员会名誉会长
        <br />
        <span class="bold">评委会主席：</span>
        杨忠才：加拿大英才音乐学院院长（温哥华）
        <br />
        <span class="bold">评委会副主席：</span
        ><span class="small">（按姓氏笔划排序）</span>
        <br />
        尤卉：美国斯坦福大学古筝教授，斯坦福古筝团/中国音乐乐团艺术总监
        <br />
        李扬：加拿大蒙特利尔胡琴研究会会长，蒙特利尔民族室内乐团艺术总监
        <br />
        刘扬：著名旅美二胡演奏家，加拿大英才音乐学院弦乐系主任、教授
        <br />
        刘桂莲：加拿大英才音乐学院弹拨系主任、教授
        <br />
        陈文英：加拿大英才音乐学院副院长，古筝学科带头人、教授
        <br />
        陈洁冰：著名旅美二胡演奏家，一级演奏员
        <br />
        陈国产：加拿大多伦多中国音乐学院院长
        <br />
        高虹：琵琶演奏家、作曲家。美国格莱美奖投票会员，卡尔顿学院世界音乐乐团和中国民乐团艺术总监
        <br />
        <span class="bold">评委会行政总监：</span>
        <br />
        何晓梅：琵琶演奏家，加拿大多伦多中国音乐学院院长
        <br />
        <span class="bold">评委会秘书长：</span>
        <br />
        白雪：加拿大加中民族乐团首席
        <br />
        南飞鸿：加拿大多伦多大学校长办公室任职
        <br />
        <span class="ban"
          >专家组评委成员：为保证比赛公正性，暂不发布具体名单</span
        >
      </div>
      <div class="key_point">
        <span class="bc_red">三、比赛章程</span>
        <br />
        <span class="bold">参赛项目：</span>
        <br />
        <span class="bc_red">独奏类</span>
        <br />
        <span class="red bold">1、拉弦乐</span>
        <br />
        二胡、高胡、中胡、板胡、京胡等民族拉弦乐器。
        <br />
        <span class="red bold">2、弹拨乐</span>
        <br />
        琵琶、古筝、扬琴、阮等民族弹拨乐器。
        <br />
        <span class="red bold">3、吹打乐</span>
        <br />
        竹笛、唢呐、笙、箫、打击等民族吹奏乐器。
        <br />
        <span class="bc_red">重奏类</span>
        <br />
        <span class="bold">弦乐重奏组</span>
        <br />
        含二胡、高胡、中胡、板胡、京胡等民族拉弦乐器组成的重奏演奏形式。
        <br />
        <span class="bold">弹拨重奏组</span>
        <br />
        含琵琶、古筝、扬琴、阮等民族弹拨乐器组成的重奏演奏形式。
        <br />
        <span class="bold">吹打乐重奏组</span>
        <br />
        含竹笛、唢呐、笙、箫、打击等民族吹奏乐器组成的重奏演奏形式。
        <br />
        <br />
        <span class="bold">参赛者范围：</span
        >在中国大陆以外国家和地区居住生活的华乐学习者、爱好者、职业演奏员
        <br />
        <span class="bold">报名起止时间：</span>10月1日-12月12日
        <br />
        <span class="bold">初赛时间：</span>12月15日
        <br />
        <span class="bold">决赛时间：</span>12月29日
        <br />
        <span class="red bold">核心提示：</span>
        <br />
        1、所有组别全部以视频方式线上评审。
        <br />
        2、职业组分为初赛、决赛两个阶段。非职业组不设决赛。
        <br />
        <span class="bc_red center" style="margin-top: 30px">比赛分组</span>
        <br />
        <span class="center">（分组截至6月30日计算年龄）</span>
        <br />
        <span class="bc_red">1、非职业组</span>
        <br />
        <span class="bold">一、少儿组：</span>
        <br />
        A组：6-9岁
        <br />
        B组：10-13岁
        <br />
        C组 ：14-17岁
        <br />
        <span class="bold">二、成年组：</span>
        <br />
        A组：18-35岁
        <br />
        B组：36-64岁
        <br />
        C组：65岁以上
        <br />
        <span class="bc_red">2、职业组</span><span class="ban">（仅限非长期居住在中国大陆人员）</span>
        <br />
        <span class="bold">职业A组：</span>14-18岁
        <br />
        专业音乐学院二胡学生
        <br />
        <span class="bold">职业B组：</span>19-45岁
        <br />
        艺术院校教师、学生及自由职业演奏员，包括各国籍外聘教师、演奏家
        <br />
        <span class="bc_red">3、重奏组</span>
        <br />
        参赛选手无年龄限制。
        <br />
        <span class="bc_red">参赛曲目说明</span>
        <br />
        <span class="red bold">I、非职业独奏组曲目说明</span>
        <br />
        比赛全程自由选择曲目一首。
        <br />
        按全曲准备，背谱演奏，不带任何形式的伴奏。
        <br />
        <span class="red bold">II、职业组曲目说明</span>
        <br />
        <span class="red bold">职业组开设二胡、琵琶、古筝、中阮四个专业项目。</span>
        <br />
        <span class="bold">初赛：</span>自选曲目一首。
        <br />
        <span class="bold">决赛：</span
        >从规定曲目中选两首，必须有一首传统或民间风格作品，不得和初赛曲目重复。
        <br />
        <span
          >职业组所有曲目按全曲准备，背谱演奏。初赛不带任何形式伴奏，决赛可带伴奏，不带伴奏也不影响评分。</span
        >
        <br />
        <span class="bc_red">规定曲目</span>
        <br />
        <span class="red bold">二胡组：</span>
        <br />
        <span class="bold">a、地方风格作品曲目</span>
        <br />
        《江南春色》（马熙林、朱昌耀曲）
        <br />
        《豫乡行》（宋国生曲）
        <br />
        《秦腔主题随想曲》（赵震霄、鲁日融编曲）
        <br />
        《故乡》（刘长福 曲）
        <br />
        《草原新牧民》（刘长福曲）
        <br />
        《春晖》（鲁建敏曲）
        <br />
        《山梁梁上的歌》（王旭曲）
        <br />
        <span class="bold">b、传统经典曲目</span>
        <br />
        《月夜》（刘天华曲）
        <br />
        《听松》（华彦钧曲）
        <br />
        《江河水》（东北民间乐曲，黄海怀移植）
        <br />
        《汉宫秋月》（古曲）
        <br />
        <span class="bold">c、当代经典创作作品曲目</span>
        <br />
        《第五二胡狂想曲》（王建民曲）
        <br />
        《阿曼尼莎》（王丹红曲）
        <br />
        《楚颂》（李博禅曲）
        <br />
        《初心》（李博禅 曲）
        <br />
        《雪山魂塑》（刘文金曲）
        <br />
        《第二二胡协奏曲——追梦京华》（关乃忠曲）
        <br />
        <span class="red bold">琵琶组：</span>
        <br />
        <span class="bold">a、地方风格作品曲目</span>
        <br />
        《草原小姐妹》（独奏版）（刘德海 吴祖强 曲）
        <br />
        《龟兹舞曲》（杨静 曲）
        <br />
        《彝族舞曲》（王惠然 编曲）
        <br />
        《江南三月》（王惠然 曲）
        <br />
        《山之舞》（陈音 曲）
        <br />
        《弦子韵》（汤良兴 曲）
        <br />
        <span class="bold">b、传统经典曲目</span>
        <br />
        《平沙落雁》
        <br />
        《塞上曲》（包括沈浩初传谱《思春》）
        <br />
        《虚籁》（刘天华 曲）
        <br />
        《改进操》（刘天华 曲）
        <br />
        《陈杏元和番》（林石城 整理）
        <br />
        《瀛洲古调》（演奏时间不少于5分钟）
        <br />
        <span class="bold">c、当代经典创作作品曲目</span>
        <br />
        《昭陵六骏》（刘德海 曲）
        <br />
        《袖剑与铜甲金戈》（陈丹布 曲）
        <br />
        《晚秋》（李博禅 曲）
        <br />
        《诉——读唐诗&lt;琵琶行&gt;有感》（吴厚元 曲）
        <br />
        《云想花想》（王丹红 曲）
        <br />
        《春蚕》（刘德海 曲）
        <br />
        《天鹅》（刘德海 曲）
        <br />
        <span class="red bold">古筝组：</span>
        <br />
        《梅花三弄》 
        <br />
        《伊犁河畔》（成公亮 曲）
        <br />
        《晚晴》（邓翊群 曲）
        <br />
        《雨莲花开》（王瑞 曲）
        <br />
        《黔中赋》（徐晓林 曲）
        <br />
        《墨客》（方荣清 曲） 
        <br />
        《层层水澜》（陶一陌 曲）
        <br />
        《林泉》（叶小钢 曲）
        <br />
        《逐日》（陈哲 曲）
        <br />
        《云岭音画》（王中山 曲）    
        <br />
        《望秦川》（景建树 王中山 曲）
        <br />
        《枫桥夜泊》（王建民 曲）
        <br />
        《苍歌引》（陈哲 曲）
        <br />
        《云裳诉》（周煜国 曲） 
        <br />
        《西楚霸王》（何占豪 曲）
        <br />
        《定风波》（邓翊群 曲）  
        <br />
        《晓雾》（王中山 曲）
        <br />
        《笙箫引》（庄曜 曲）
        <br />
        《风之猎》（陶一陌 曲）
        <br />
        《行者》（魏军 曲） 
        <br />
        《西部主题随想曲》（黄秋宇 周望 曲）
        <br />
        <span class="red bold">中阮组：</span>
        <br />
        《丝路驼铃》（宁勇 曲）
        <br />
        《悠远的歌声》 （陈文杰 曲）
        <br />
        《思恋》 （林吉良 曲）
        <br />
        《草原抒怀》 （林吉良 曲）
        <br />
        《满江红》 （林吉良 曲）
        <br />
        《游泰山》 （林吉良 曲）
        <br />
        《葡萄架下》 （林吉良 曲）
        <br />
        《火把节之夜》 （吴俊生 曲）
        <br />
        《山韵之二——涧》 （周煜国 曲）
        <br />
        《绽放》 郑翠萍 （苏文庆 曲）
        <br />
        《山歌》 （刘星 曲）
        <br />
        《即兴曲》 （刘星 曲）
        <br />
        《孤芳自赏》 （刘星 曲）
        <br />
        《云南回忆第一乐章》 （刘星 曲）
        <br />
        《云南回忆第三乐章》 （刘星 曲）
        <br />
        《味道还在 第一乐章》 （温展力 曲）
        <br />
        <span class="red bold">III、重奏组</span>
        <br />
        比赛全程自选曲目一首。（ 不带伴奏）
        <br />
        每个参赛组合人数为4人-16人，曲目及演奏形式不限。曲目时间为3-8分钟。参赛作品至少两个声部，齐奏及同声部演奏的作品和形式不在本次比赛的范畴。
      </div>
      <div class="key_point">
        <span class="bc_red">四、比赛方式</span>
        <br />
        <span class="bold">（一）报名及初赛</span>
        <br />
        1.1、网络在线报名，请关注微信公众号：加拿大英才音乐交流
        获取比赛信息。10月1日-12月12日请登录比赛官方网站www.canadaecc.cn<router-link to="login">
          <!-- <span class="clickToGoIn">点击进入</span> -->
          </router-link><router-link to="login">
          <img
            class="register_entry"
            src="../../assets/search_entry.jpg"
            alt="" /></router-link
        >，连同初赛评审费一起交纳办理。完成报名后上传初赛视频。每个视频文件以选手姓名+组别命名。填写在线报名表时，请务必认真检查，姓名应与身份证明一致，一个联络手机号码电话只报名一位选手。（最晚12月12日提交初赛视频）
        <br />
        1.2、纸质报名:<a href="/Public/Form/2025_Registration_Form.pdf" download>报名表</a>
        <br />
        报名咨询电话：+1（604）278-7730
        <br />
        请扫描下方二维码关注组委会微信公众号, 以方便及时了解比赛最新通知信息。比赛咨询微信: canadaycmusicacademy。
        <br />
        <img src="../../assets/code.png" alt="" />&nbsp;
        <img src="../../assets/code_canadaycmusicacademy.png" alt="" />
        <br />
        2、比赛一律采用评委审看选手录像视频的方式进行。
        <br />
        <span class="bold">视频要求</span>
        <div style="margin-left: 2em">
          a、演奏者在光线明亮处，正面向摄像机镜头，设定合适的距离以确保演奏清晰可见。
          <br />
          b、比赛视频文件名以选手的姓名组别命名。
          <br />
          c、比赛视频不得进行艺术美化性质的编辑，包括图像和音频的剪辑拼接，且必须为同期录音，严格要求声像同步。
          <br />
          d、比赛视频文件格式为MP4 ,清晰度为1280*720p或720*576p。
          <br />
          e、报名录像资料不予退还。
          <br />
        </div>
        3、初赛评审费：独奏类 $80加元/人 ，重奏组 $25加元/人。
        <br />
        4、选手资料和报名费全部收到后组委会将以电子邮件的形式告知选手确认报名成功。
        <br />
        5、2025年12月15日左右在微信公众号：加拿大英才音乐交流与活动官方网站www.canadaecc.cn发布比赛结果。
        <br />
        <span class="bold">（二）决赛 </span>
        <br />
        职业组入围参赛选手必须于12月20 日-12月27日按照初赛报名流程，在
        线办理下阶段比赛手续，未入围下阶段比赛的选手，组委会不再通知，所交资料和评审费不予退还。
        <br />
        <span class="bold">决赛时间： </span>2025年12月29日
        <br />
        <span class="bold">决赛评审费： </span>$120加元/人
      </div>
      <div class="key_point">
        <span class="bc_red">五、奖项设置</span>
        <br />
        1、各组别均设金奖、银奖、铜奖、优秀演奏奖、优秀奖若干名。
        <br />
        2、组委会将对荣获金、银奖选手的指导教师以及有多名学生进入决赛的指导教师颁发"优秀指导教师奖"。
        <br />
        3、奖品及奖金：
        <br />
        评委会特别奖
        <br />
        二胡专业：综合非职业组评审得分最高的选手和职业组评审得分最高的选手将各获得“敦煌牌”精品乐器一把；
        <br />
        二胡专业以外的其他所有专业和组别中依据评委团最终评分，从弹拨、吹管专业独奏及重奏组别中共评出两位"评委会特别奖"，每位获奖选手获得奖金300（加元）。
        <br />
        所有获奖者均获得精美获奖证书一份。
      </div>
      <div class="key_point">
        <span class="bc_red">六、报名费支付方式</span>
        <br />
        本次大赛以接受 Paypal、E-transfer、微信(WeChat Pay)、支付宝(AliPay)，以及Stripe等方式支付报名费, 支付完成请截图留存，后续报名阶段需要。
        <br />
        1、Paypal账号：canadaecc.office@gmail.com
        <br />
        2、E-transfer：canadaycmusicoffice@gmail.com
        <br />
        3、使用微信或支付宝扫码支付
        <br />
        <button @click="show_paycode2 = !show_paycode2">
          支付二维码
        </button>
        <div v-if="show_paycode2">
          <img src="../../assets/codepay2.jpg" style="width: 25%;" alt="" />
        </div>
        <br />
        4、 使用Stripe支付: 
        <a href="https://buy.stripe.com/7sY7sLc8w65u8qm3UM5os01" target="_blank">Stripe在线支付</a>
        <br />
      </div>
      <div class="key_point">
        <span class="bc_red">七、注意事项</span>
        <br />
        1、所有选手一旦报名参赛，即表明自己认可本章程。因此都必须遵守本章程的各项规定。
        <br />
        2、本次活动报名及参赛过程均电子化，获奖证书打印按报名信息打印，填写在线报名表时，请务必认真检查，姓名应与身份证明一致，一个联络手机号码电话只报名一位选手，如因填表内容有错而造成损失的，完全由本人负责。
        <br />
        3、组委会拥有本赛事音像制品的广播、电视播放权及音像制品表演范围内的使用、出版和发行权。获奖选手有义务参加组委会组织安排的公益性演出或出访演出活动。
        <br />
        4、凡因选手本人原因，届时未参加比赛的，不退评审费。
        <br />
        5、参赛选手所报送的视频，必须是每人一份文件，不允许多人录在同一视频文件上。
        <br />
        6、如遇不可抗力因素取消或推迟活动，组委会将在官方网站公布相关信息。
        <br />
        注：本章程解释权归本届展演活动组委会所有。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data(){
      return{
          show_paycode2: false,
          show_paycode4: false,
      }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
p {
  text-indent: 2em;
  text-align: justify;
  margin: 4px 0;
  line-height: 30px;
}
pre {
  font-size: 16px;
}
.title_first {
  font-size: 28px;
  color: #c0504d;
  text-align: center;
}
.title_second {
  font-size: 22px;
  color: #c0504d;
  text-align: center;
}
.constitution {
  width: 95%;
  margin: 0 auto;
}
.key_point {
  margin: 30px 0;
  text-align: justify;
  line-height: 30px;
}
.key_point span {
  display: inline-block;
}
.key_point img {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.key_point .bc_red {
  display: inline-block;
  font-size: 18px;
  background-color: #c0504d;
  color: white;
  margin-bottom: 3px;
  font-weight: bold;
}
.key_point .bold {
  font-weight: bold;
}
.key_point .small {
  font-size: 12px;
}
.key_point .ban {
  color: #ccc;
}
.key_point .red {
  color: #c0504d;
  font-weight: bold;
}
.key_point .center {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.key_point .content {
  text-indent: 0;
  margin-left: 7em;
  margin-top: 0;
}
.key_point .register_entry {
  width: 200px;
  position: fixed;
  bottom: 0;
  left: 100%;
  transform: translateX(-100%);
  z-index: 2;
}
.clickToGoIn {
  font-size: 26px;
  color: red;
  font-weight: bold;
}
</style>
